import { AxiosInstance } from 'axios'

import { userApiDefaultApiFactory } from '@src/api/default-api-factories'
import {
  DefaultApiAnalyzeEvidenceRequest,
  DefaultApiGetTeamsTeamRequest,
  DefaultApiGetTeamsChannelsWithCursorRequest,
  DefaultApiGetTeamsChannelRequest,
  DefaultApiGetTeamsCardNotificationSettingsRequest,
  DefaultApiCreateTeamsCardNotificationsRequest,
  DefaultApiUpdateTeamsNotificationSettingForCardRequest,
  DefaultApiDeleteTeamsNotificationSettingForCardRequest,
  DefaultApiMoveTeamsNotificationSettingForCardRequest,
  // Do Not Remove this line ===@import api type===
} from '@src/api/generated/user-api'

export const teams = async (
  instance: AxiosInstance,
  params: DefaultApiAnalyzeEvidenceRequest
) => {
  return await userApiDefaultApiFactory(instance).analyzeEvidence(params)
}

export const getTeamsTeam = async (
  instance: AxiosInstance,
  params: DefaultApiGetTeamsTeamRequest
) => {
  return await userApiDefaultApiFactory(instance).getTeamsTeam(params)
}

export const getTeamsChannelsWithCursor = async (
  instance: AxiosInstance,
  params: DefaultApiGetTeamsChannelsWithCursorRequest
) => {
  return await userApiDefaultApiFactory(instance).getTeamsChannelsWithCursor(
    params
  )
}

export const getTeamsChannel = async (
  instance: AxiosInstance,
  params: DefaultApiGetTeamsChannelRequest
) => {
  return await userApiDefaultApiFactory(instance).getTeamsChannel(params)
}

export const getTeamsCardNotificationSettings = async (
  instance: AxiosInstance,
  params: DefaultApiGetTeamsCardNotificationSettingsRequest
) => {
  return await userApiDefaultApiFactory(
    instance
  ).getTeamsCardNotificationSettings(params)
}

export const createTeamsCardNotifications = async (
  instance: AxiosInstance,
  params: DefaultApiCreateTeamsCardNotificationsRequest
) => {
  return await userApiDefaultApiFactory(instance).createTeamsCardNotifications(
    params
  )
}

export const updateTeamsNotificationSettingForCard = async (
  instance: AxiosInstance,
  params: DefaultApiUpdateTeamsNotificationSettingForCardRequest
) => {
  return await userApiDefaultApiFactory(
    instance
  ).updateTeamsNotificationSettingForCard(params)
}

export const deleteTeamsNotificationSettingForCard = async (
  instance: AxiosInstance,
  params: DefaultApiDeleteTeamsNotificationSettingForCardRequest
) => {
  return await userApiDefaultApiFactory(
    instance
  ).deleteTeamsNotificationSettingForCard(params)
}

export const moveTeamsNotificationSettingForCard = async (
  instance: AxiosInstance,
  params: DefaultApiMoveTeamsNotificationSettingForCardRequest
) => {
  return await userApiDefaultApiFactory(
    instance
  ).moveTeamsNotificationSettingForCard(params)
}

// Do Not Remove this line ===@import api client===
